import { createContext } from 'react';

import { RoleDetails } from '@shared/types/role.ts';

export const RolesDetailsContext = createContext<RoleDetails[] | undefined>(undefined);
